import React, { useState, useEffect } from 'react';

const Clock = () => {
  const [clock, setClock] = useState('');

  useEffect(() => {
    const timer = setInterval(() => {
      const weekday = [
        'Domingo',
        'Segunda',
        'Terça',
        'Quarta',
        'Quinta',
        'Sexta',
        'Sábado'
      ];
      const date = new Date();
      setClock(`${weekday[date.getDay()]} ${date.toLocaleString()}`);
    }, 1000);

    return () => {
      clearInterval(timer);
    };
  }, [setClock]);

  return <h4 className="text-light text-clock m-0">{clock}</h4>;
};

export default Clock;
